/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AreaIndicatorsDto } from '../models';
// @ts-ignore
import type { EmployeeAccessTypeDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LanguageDto } from '../models';
/**
 * TeamAreaIndicatorsApi - axios parameter creator
 * @export
 */
export const TeamAreaIndicatorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Jeden odczyt zasilajacy kafelki zakladki \"Dashboard HRBP\" oraz liczniki sekcji HRBP na stronie startowej. Odsetki nie sa zwracane gotowe — liczby i wspolny mianownik wystarcza, zeby oba miejsca policzyly je tak samo. 
         * @summary Headline indicators of the caller\'s area (JAIN-497, JAIN-506)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAreaIndicators: async (accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/team/development/area-indicators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accessType !== undefined) {
                localVarQueryParameter['accessType'] = accessType;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamAreaIndicatorsApi - functional programming interface
 * @export
 */
export const TeamAreaIndicatorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamAreaIndicatorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Jeden odczyt zasilajacy kafelki zakladki \"Dashboard HRBP\" oraz liczniki sekcji HRBP na stronie startowej. Odsetki nie sa zwracane gotowe — liczby i wspolny mianownik wystarcza, zeby oba miejsca policzyly je tak samo. 
         * @summary Headline indicators of the caller\'s area (JAIN-497, JAIN-506)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readAreaIndicators(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AreaIndicatorsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readAreaIndicators(accessType, lang, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamAreaIndicatorsApi.readAreaIndicators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamAreaIndicatorsApi - factory interface
 * @export
 */
export const TeamAreaIndicatorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamAreaIndicatorsApiFp(configuration)
    return {
        /**
         * Jeden odczyt zasilajacy kafelki zakladki \"Dashboard HRBP\" oraz liczniki sekcji HRBP na stronie startowej. Odsetki nie sa zwracane gotowe — liczby i wspolny mianownik wystarcza, zeby oba miejsca policzyly je tak samo. 
         * @summary Headline indicators of the caller\'s area (JAIN-497, JAIN-506)
         * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
         * @param {LanguageDto} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readAreaIndicators(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<AreaIndicatorsDto> {
            return localVarFp.readAreaIndicators(accessType, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamAreaIndicatorsApi - interface
 * @export
 * @interface TeamAreaIndicatorsApi
 */
export interface TeamAreaIndicatorsApiInterface {
    /**
     * Jeden odczyt zasilajacy kafelki zakladki \"Dashboard HRBP\" oraz liczniki sekcji HRBP na stronie startowej. Odsetki nie sa zwracane gotowe — liczby i wspolny mianownik wystarcza, zeby oba miejsca policzyly je tak samo. 
     * @summary Headline indicators of the caller\'s area (JAIN-497, JAIN-506)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamAreaIndicatorsApiInterface
     */
    readAreaIndicators(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig): AxiosPromise<AreaIndicatorsDto>;

}

/**
 * TeamAreaIndicatorsApi - object-oriented interface
 * @export
 * @class TeamAreaIndicatorsApi
 * @extends {BaseAPI}
 */
export class TeamAreaIndicatorsApi extends BaseAPI implements TeamAreaIndicatorsApiInterface {
    /**
     * Jeden odczyt zasilajacy kafelki zakladki \"Dashboard HRBP\" oraz liczniki sekcji HRBP na stronie startowej. Odsetki nie sa zwracane gotowe — liczby i wspolny mianownik wystarcza, zeby oba miejsca policzyly je tak samo. 
     * @summary Headline indicators of the caller\'s area (JAIN-497, JAIN-506)
     * @param {EmployeeAccessTypeDto} [accessType] Zakres widoczności pracowników (widok v_user_employee_access). Wartość domyślną ustala endpoint.
     * @param {LanguageDto} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamAreaIndicatorsApi
     */
    public readAreaIndicators(accessType?: EmployeeAccessTypeDto, lang?: LanguageDto, options?: RawAxiosRequestConfig) {
        return TeamAreaIndicatorsApiFp(this.configuration).readAreaIndicators(accessType, lang, options).then((request) => request(this.axios, this.basePath));
    }
}

